import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { withCustomParams } from '../../../NRReactGrid/withCustomParams';
import EllipsisTypography from '../../../EllipsisTypography/EllipsisTypography';
import { useTheme } from '@mui/material/styles';

const CorrelationsGridNameLinkFormatter = ({ value, row, closeModal }) => {
  const theme = useTheme();
  const pathToRedirect = `/assets/${row.assetId}`;

  return (
    <Box sx={{ display: 'flex' }}>
      <Link to={pathToRedirect} onClick={() => closeModal()} style={{ cursor: 'pointer', textDecoration: 'unset', color: theme.palette.blue.link }}>
        <EllipsisTypography>{value}</EllipsisTypography>
      </Link>
    </Box>
  );
};
export const CorrelationsGridNameLinkProvider = ({ extraParams, ...props }) => {
  const CustomLinkFormatter = withCustomParams(CorrelationsGridNameLinkFormatter, extraParams);

  return <DataTypeProvider formatterComponent={CustomLinkFormatter} {...props} />;
};
